import DayEndDateInput from './input';

export default DayEndDateInput;
